import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './index.module.scss';

interface CountTagProps {
  unreadNotificationCount?: number;
}

const CountTag = ({ unreadNotificationCount }: CountTagProps) => {
  if (!unreadNotificationCount || unreadNotificationCount < 1) {
    return null;
  }

  const displayCount = unreadNotificationCount > 99 ? '99+' : unreadNotificationCount;

  return (
    <Typography variant="h6" className={styles.notificationsCount}>
      {displayCount}
    </Typography>
  );
};

export default CountTag;
